var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlowIntegration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 220,
    rx: 8,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.5 110V130.46C138.5 134.9 134.9 138.5 130.46 138.5H89.54C85.1 138.5 81.5 134.9 81.5 130.46V89.54C81.5 85.1 85.1 81.5 89.54 81.5H110",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110 81.5H130.46C134.9 81.5 138.5 85.1 138.5 89.54V110",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110 110H101.39C100.68 110 100.29 109.2 100.71 108.62C101.46 107.6 101.9 106.35 101.9 104.99C101.9 101.47 98.93 98.63 95.35 98.86C92.34 99.05 89.88 101.47 89.63 104.47C89.5 106.03 89.96 107.48 90.81 108.63C91.23 109.19 90.82 109.99 90.12 109.99H81.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110 110H118.61C119.32 110 119.71 110.8 119.29 111.38C118.54 112.4 118.1 113.65 118.1 115.01C118.1 118.53 121.07 121.37 124.65 121.14C127.66 120.95 130.12 118.53 130.37 115.53C130.5 113.97 130.04 112.52 129.19 111.37C128.77 110.81 129.18 110.01 129.88 110.01H138.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110 110V101.39C110 100.68 110.8 100.29 111.38 100.71C112.4 101.46 113.65 101.9 115.01 101.9C118.53 101.9 121.37 98.93 121.14 95.35C120.95 92.34 118.53 89.88 115.53 89.63C113.97 89.5 112.52 89.96 111.37 90.81C110.81 91.23 110.01 90.82 110.01 90.12V81.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110 110V118.61C110 119.32 109.2 119.71 108.62 119.29C107.6 118.54 106.35 118.1 104.99 118.1C101.47 118.1 98.63 121.07 98.86 124.65C99.05 127.66 101.47 130.12 104.47 130.37C106.03 130.5 107.48 130.04 108.63 129.19C109.19 128.77 109.99 129.18 109.99 129.88V138.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlowIntegration);
export default __webpack_public_path__ + "static/media/icon-flow-integration.df266e711d79bc2cea00922617b4a725.svg";
export { ForwardRef as ReactComponent };